import { Component } from "@/types"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "magicCircle"

export const presets = {}

export interface Props extends Component {}

export function MagicCircle({ className, testId = COMPONENT_NAME }: Props) {
  return (
    <div
      className={cx(
        `size-[1400px] border-[160px] border-teal-400 rounded-full absolute pointer-events-none`,
        className,
      )}
      data-test={testId}
    />
  )
}
